import { render, staticRenderFns } from "./InaccessibleRegionRedirectWarning.vue?vue&type=template&id=796f4a22"
import script from "./InaccessibleRegionRedirectWarning.vue?vue&type=script&lang=js"
export * from "./InaccessibleRegionRedirectWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports